import axios from 'axios'

const APP_ID = 'sx_open_f52bc80ec1f64b78'
const APP_SECRET = 'QEWzon7_sUy644b7E_Z9APpwncGE3EPIsp0Y1OAnYd0'
const OPEN_API_BASE = '/open-api'

// MD5 implementation based on Joseph Myers' code
var md5cycle = function (x, k) {
  var a = x[0], b = x[1], c = x[2], d = x[3]

  a = ff(a, b, c, d, k[0], 7, -680876936)
  d = ff(d, a, b, c, k[1], 12, -389564586)
  c = ff(c, d, a, b, k[2], 17, 606105819)
  b = ff(b, c, d, a, k[3], 22, -1044525330)
  a = ff(a, b, c, d, k[4], 7, -176418897)
  d = ff(d, a, b, c, k[5], 12, 1200080426)
  c = ff(c, d, a, b, k[6], 17, -1473231341)
  b = ff(b, c, d, a, k[7], 22, -45705983)
  a = ff(a, b, c, d, k[8], 7, 1770035416)
  d = ff(d, a, b, c, k[9], 12, -1958414417)
  c = ff(c, d, a, b, k[10], 17, -42063)
  b = ff(b, c, d, a, k[11], 22, -1990404162)
  a = ff(a, b, c, d, k[12], 7, 1804603682)
  d = ff(d, a, b, c, k[13], 12, -40341101)
  c = ff(c, d, a, b, k[14], 17, -1502002290)
  b = ff(b, c, d, a, k[15], 22, 1236535329)

  a = gg(a, b, c, d, k[1], 5, -165796510)
  d = gg(d, a, b, c, k[6], 9, -1069501632)
  c = gg(c, d, a, b, k[11], 14, 643717713)
  b = gg(b, c, d, a, k[0], 20, -373897302)
  a = gg(a, b, c, d, k[5], 5, -701558691)
  d = gg(d, a, b, c, k[10], 9, 38016083)
  c = gg(c, d, a, b, k[15], 14, -660478335)
  b = gg(b, c, d, a, k[4], 20, -405537848)
  a = gg(a, b, c, d, k[9], 5, 568446438)
  d = gg(d, a, b, c, k[14], 9, -1019803690)
  c = gg(c, d, a, b, k[3], 14, -187363961)
  b = gg(b, c, d, a, k[8], 20, 1163531501)
  a = gg(a, b, c, d, k[13], 5, -1444681467)
  d = gg(d, a, b, c, k[2], 9, -51403784)
  c = gg(c, d, a, b, k[7], 14, 1735328473)
  b = gg(b, c, d, a, k[12], 20, -1926607734)

  a = hh(a, b, c, d, k[5], 4, -378558)
  d = hh(d, a, b, c, k[8], 11, -2022574463)
  c = hh(c, d, a, b, k[11], 16, 1839030562)
  b = hh(b, c, d, a, k[14], 23, -35309556)
  a = hh(a, b, c, d, k[1], 4, -1530992060)
  d = hh(d, a, b, c, k[4], 11, 1272893353)
  c = hh(c, d, a, b, k[7], 16, -155497632)
  b = hh(b, c, d, a, k[10], 23, -1094730640)
  a = hh(a, b, c, d, k[13], 4, 681279174)
  d = hh(d, a, b, c, k[0], 11, -358537222)
  c = hh(c, d, a, b, k[3], 16, -722521979)
  b = hh(b, c, d, a, k[6], 23, 76029189)
  a = hh(a, b, c, d, k[9], 4, -640364487)
  d = hh(d, a, b, c, k[12], 11, -421815835)
  c = hh(c, d, a, b, k[15], 16, 530742520)
  b = hh(b, c, d, a, k[2], 23, -995338651)

  a = ii(a, b, c, d, k[0], 6, -198630844)
  d = ii(d, a, b, c, k[7], 10, 1126891415)
  c = ii(c, d, a, b, k[14], 15, -1416354905)
  b = ii(b, c, d, a, k[5], 21, -57434055)
  a = ii(a, b, c, d, k[12], 6, 1700485571)
  d = ii(d, a, b, c, k[3], 10, -1894986606)
  c = ii(c, d, a, b, k[10], 15, -1051523)
  b = ii(b, c, d, a, k[1], 21, -2054922799)
  a = ii(a, b, c, d, k[8], 6, 1873313359)
  d = ii(d, a, b, c, k[15], 10, -30611744)
  c = ii(c, d, a, b, k[6], 15, -1560198380)
  b = ii(b, c, d, a, k[13], 21, 1309151649)
  a = ii(a, b, c, d, k[4], 6, -145523070)
  d = ii(d, a, b, c, k[11], 10, -1120210379)
  c = ii(c, d, a, b, k[2], 15, 718787259)
  b = ii(b, c, d, a, k[9], 21, -343485551)

  x[0] = add32(a, x[0])
  x[1] = add32(b, x[1])
  x[2] = add32(c, x[2])
  x[3] = add32(d, x[3])
}

var state = [1732584193, -271733879, -1732584194, 271733878]

var ff = function (a, b, c, d, x, s, t) {
  return nn((a + ((b & c) | ((~b) & d)) + x + t) | 0, s) + b
}

var gg = function (a, b, c, d, x, s, t) {
  return nn((a + ((b & d) | (c & (~d))) + x + t) | 0, s) + b
}

var hh = function (a, b, c, d, x, s, t) {
  return nn((a + (b ^ c ^ d) + x + t) | 0, s) + b
}

var ii = function (a, b, c, d, x, s, t) {
  return nn((a + (c ^ (b | (~d))) + x + t) | 0, s) + b
}

var add32 = function (a, b) {
  return (a + b) | 0
}

var nn = function (x, n) {
  return (x << n) | (x >>> (32 - n))
}

var rhex = function (n) {
  var s = '', j = 0
  for (; j < 4; j++) {
    s += ((n >> (j * 8 + 4)) & 0x0F).toString(16) + ((n >> (j * 8)) & 0x0F).toString(16)
  }
  return s
}

var hex = function (x) {
  for (var i = 0; i < x.length; i++) {
    x[i] = rhex(x[i])
  }
  return x.join('')
}

var md5blk = function (s) {
  var md5blks = [], i
  for (i = 0; i < 64; i += 4) {
    md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24)
  }
  return md5blks
}

var md5 = function (s) {
  var n = s.length,
    state = [1732584193, -271733879, -1732584194, 271733878],
    i,
    tail,
    tmp,
    lo,
    hi

  for (i = 64; i <= n; i += 64) {
    md5cycle(state, md5blk(s.substring(i - 64, i)))
  }
  s = s.substring(i - 64)
  tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  for (i = 0; i < s.length; i++) {
    tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3)
  }
  tail[i >> 2] |= 0x80 << ((i % 4) << 3)
  if (i > 55) {
    md5cycle(state, tail)
    for (i = 0; i < 16; i++) {
      tail[i] = 0
    }
  }
  tmp = n * 8
  tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/)
  lo = parseInt(tmp[2], 16)
  hi = parseInt(tmp[1], 16) || 0
  tail[14] = lo
  tail[15] = hi
  md5cycle(state, tail)
  return hex(state)
}

function buildHeaders() {
  var timestamp = Math.floor(Date.now() / 1000).toString()
  var nonce = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
  var raw = APP_ID + timestamp + nonce + APP_SECRET
  var sign = md5(raw)
  return {
    'X-App-Id': APP_ID,
    'X-Timestamp': timestamp,
    'X-Nonce': nonce,
    'X-Sign': sign
  }
}

export function getReportStages(proId, stuId, page, pageSize) {
  return axios.get(OPEN_API_BASE + '/report/stages', {
    params: { pro_id: proId, stu_id: stuId, page: page || 1, page_size: pageSize || 50 },
    headers: buildHeaders()
  })
}

export function getReportList(proId, params) {
  return axios.get(OPEN_API_BASE + '/report/list', {
    params: Object.assign({ pro_id: proId, page: 1, page_size: 15 }, params || {}),
    headers: buildHeaders()
  })
}

export function getReportDetail(reportId) {
  return axios.get(OPEN_API_BASE + '/report/detail/' + reportId, {
    headers: buildHeaders()
  })
}

export function getStudentStages(proId, stuId, page, pageSize) {
  return axios.get(OPEN_API_BASE + '/report/student/stages', {
    params: { pro_id: proId, stu_id: stuId, page: page || 1, page_size: pageSize || 50 },
    headers: buildHeaders()
  })
}

export function getStudentReports(proId, stuId, params) {
  return axios.get(OPEN_API_BASE + '/report/student', {
    params: Object.assign({ pro_id: proId, stu_id: stuId, page: 1, page_size: 15 }, params || {}),
    headers: buildHeaders()
  })
}
